export class LoginCheckHelper{

      ValidateEmail(emailVal){
    let email = emailVal;
    let localPartStatus = true;
     let domainStatus = true;
     let domainPartStatus = true;
     let dotIndex = 1;
    let domainIndex = email.search('@') + 1;
    let domainCheck = email.search('/') + 1;
    let dotcheck = email.includes("..");
    if(domainIndex !== 0 || domainCheck !== 0 || dotcheck === true){
    // if (domainIndex === 0) localPart = email;
    // else localPart = email.substring(0, domainIndex);
    let localPart = email.substring(0, domainIndex);
    let localPartRegExp = new RegExp("^(?!.{66})(['*()!$&@{|}+\\-\\a-z0-9=A-Z^-~]+[.])*['*!$&@{|}+\\-\\a-z0-9=A-Z^-~]+(([A-Za-z]))*$");
    let domainRegExp = new RegExp("^([-\\a-zA-Z0-9]{1,52}[.])*[-\\a-zA-Z0-9]{2,20}$");
    let domain = email.substring(domainIndex, email.length);
     domainPartStatus = domainRegExp.test(domain);
     dotIndex = domain.indexOf('.');
    localPartStatus = localPartRegExp.test(localPart);
    if (email.length > 254) {
      domainStatus = false; } 
    }
      return (localPartStatus && domainStatus && domainPartStatus && dotIndex !== -1);
    }

    isValidPassword(str) {
      var re = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,128}$/);
      return (re.test(str));
    }
       isDuplicateLogin(){
      app.pubSubService.unsubscribe('PubSubSessionExpiry');
      const isAuth = app.appService.isAuthenticated();
      if (isAuth === true) {
          app.identityService.logout().then((response) => {
              let addToHomeScreenPopUpData = localStorage.getItem(window.location.hostname);
              let userRememberMe = app.appService.getSessionstorage('rememberMe');
              let userpath = JSON.parse(localStorage.getItem('redirectLoopPath'));
              app.appService.deleteSessionData();
              app.appService.removeSessionStorageItem('handleNewVerificationFlag');
              let phoneNumber = app.appService.getLocalStorage("SelectedPhoneNumber");
              app.identityService.handleUserLogout();
              if (phoneNumber) {
                   app.appService.setLocalStorage("SelectedPhoneNumber", phoneNumber);}
              if (addToHomeScreenPopUpData) {
                  localStorage.setItem(window.location.hostname, addToHomeScreenPopUpData);
              }
              app.appService.setSessionstorage('rememberMe', userRememberMe);
              app.appService.setLocalStorage('userpath', userpath);
          }, error => {
              app.logger.getLogger().error("error " + error);
          }); }
    }
}
